/* eslint-disable linebreak-style */
<template>
  <div>
    <div v-if="this.content.contentObject">
      <div class="edit-tolbar" v-if="isContentManagerPage">
        <buttons-toolbar
          :is-vertical="windowWidth < 750"
          @save="onSaveClick"
          @delete="onConfirmDeleteContent"
          @close="closeContent"
        />
      <br>
      <br>
      </div>

      <!-- EDIT MODE -->
      <div v-show="isEditMode">
        <!-- Заголовок -->
        <h5 class="mb-3">
          <router-link to='./'>{{ titlePrefix }}</router-link> /
        </h5>

        <div class="mb-3 title-edit">
          <h4>Заголовок</h4>
          <b-form-input
            :value="content.contentObject.title"
            placeholder="Введите название"
            @input="titleChange" />
          <b-form-invalid-feedback
            :force-show="isEditMode ? content.contentObject.title === null : false"
          >
            Заголовок не может быть пустым
          </b-form-invalid-feedback>
        </div>
        <!-- Дата -->
        <div class="mb-3 date-edit" v-if="contentType === types_.event">
          <h4>Дата</h4>
          <wysiwyg-text-editor dataType="date" emptyToolbar></wysiwyg-text-editor>
        </div>

        <!-- Аватар -->
        <div id='imageDiv'>
          <img
            id="avatar-image"
            :src="avatar"
            @click="changeAvatar"
            @error="$event.target.src = defaultImage"
            alt="Аватар"
            class="mb-3"
            height="190px"
            width="300px"
          >
          <b-button
            @click="onDeleteAvatar"
            v-b-tooltip.hover
            title="Удалить аватар"
            variant="primary"
            class="fa fa-times position-relative"
            style="top: -80px; right: 45px;"
          ></b-button>
          <b-button
            @click="changeAvatar"
            v-b-tooltip.hover
            title="Изменить аватар. Поддерживаемые форматы: .jpg, .png"
            variant="primary"
            class="fa fa-edit position-relative"
            style="top: -80px; right: 130px;"
          ></b-button>
        </div>

        <!-- Краткое описание -->
        <div id="shortInfoDiv" class="mb-3">
          <h4>Краткое описание</h4>
          <wysiwyg-text-editor dataType="shortDescription" shortDescription></wysiwyg-text-editor>
        </div>

        <!-- Полное описание -->
        <div id="fullInfoDiv" class="mb-3">
          <div class="fullInfoHeader">
            <h4 class="d-inline">Описание</h4>
            <b-badge v-b-tooltip.hover title="Максимальная длина описания - 100 000 символов" class="descriptionInfoIcon" variant="primary"><em class="fas fa-info"></em></b-badge>
            <b-button
              variant="outline-primary"
              @click="addFileLink"
              class="float-right"
            > <em class="fa fa-plus mr-1"></em> Добавить ссылку на файл</b-button>
          </div>
          <div class="fullInfoEditor">
          </div>
          <wysiwyg-text-editor dataType="fullDescription"></wysiwyg-text-editor>
        </div>

        <!-- Карусель с фото -->
        <div id="imagesDiv" style="clear:both;" v-if="content.contentObject.type !== typeTranslates_.course">
          <photo-carousel
            :images="images"
            :window-width="windowWidth"
            @add="addPhoto"
            @delete="confirmDeletePhoto"
            @show="onShowPhoto"
          />
        </div>
        <!-- Карусель с видео -->
        <div id="videosDiv" style="clear:both;">
          <video-carousel
            :videos="videos"
            :window-width="windowWidth"
            @add="addVideo"
            @delete-preview="confirmDeletePreview"
            @update-preview="updatePreview"
            @delete="confirmDeleteVideo"
            @show="onShowVideo"
          />
        </div>
        <div v-if="contentType === types_.event && isEditMode">
          <VotingParticipation />
        </div>
        <div v-if="contentType === types_.event && isEditMode">
          <EditVoting />
        </div>
      </div>

      <!-- ЕСЛИ НЕ EDIT MODE -->
      <content-info v-show="!isEditMode" ref="VContentInfoPage" :withVoting="!isEditMode"></content-info>
      <div>
        <!-- Переписка при отклонении публикации спецом по режиму -->
        <content-accept :beforeSendToVerification="onSaveClick" />
      </div>

      <!-- Модальное окно подтверждения снятия с публикации (не удаления) -->
      <modal-delete-confirmation />
      <!-- Модальное окно загрузки файла -->
      <v-modal-files-upload :wrkspcType="workspaceType" />

      <!-- Модальное окно подтверждения удаления -->
      <modal-delete-file @delete="onDeleteFile" />
      <!-- Модальное окно подтверждения удаления -->
      <modal-delete-preview @delete="onDeletePreview" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import { types, typeTranslates } from '@/config/content/types'
import { statusFilters } from '@/config/content/statuses'


import UserMixin from '@/components/helpers/mixins/user-mixin'
import ContentInfo from '@/components/content/ContentInfo.vue'
import ContentAccept from '@/components/content/verification/ContentAccept.vue'
import VotingParticipation from '@/components/content/events/voting/Participation.vue'
import EditVoting from '@/components/content/events/voting/choice/Settings.vue'
import VideoCarousel from '@/components/content/edit/carousel/VideoCarousel.vue'
import PhotoCarousel from '@/components/content/edit/carousel/PhotoCarousel.vue'
import ButtonsToolbar from '@/components/content/edit/ButtonsToolbar.vue'

const WysiwygTextEditor = () => import('@/components/content/edit/WysiwygTextEditor.vue')
const ModalDeleteConfirmation = () => import('@/components/content/edit/modals/ModalDeleteConfirmation.vue')
const ModalDeleteFile = () => import('@/components/content/edit/modals/ModalDeleteFile.vue')
const ModalDeletePreview = () => import('@/components/content/edit/modals/ModalDeletePreview.vue')
const VModalFilesUpload = () => import('@/components/content/edit/modals/ModalFilesUpload.vue')

export default {
  name: 'EditContentInfo',
  mixins: [UserMixin],
  components: {
    ButtonsToolbar,
    PhotoCarousel,
    VideoCarousel,
    ModalDeletePreview,
    ModalDeleteFile,
    VotingParticipation,
    EditVoting,
    WysiwygTextEditor,
    ModalDeleteConfirmation,
    VModalFilesUpload,
    ContentInfo,
    ContentAccept
  },
  data() {
    return {
      fileOnDelete: null,
      defaultImage: '/images/w1400_1.jpg',
      workspaceType: null,
      isResultOfVerSending: false,
      newTitle: '',
      windowWidth: 0,
      types_: types,
      typeTranslates_: typeTranslates
    }
  },
  updated() {
    if (this.content.contentObject) {
      this.onCheckRouteForVerSpec()
      this.onCheckRouteType()
    }
  },
  mounted() {
    this.windowWidth = window.innerWidth
    if (this.content.contentObject) {
      this.onCheckRouteForVerSpec()
      this.onCheckRouteType()
    }
    document.addEventListener('keydown', this.CtrlSListener)
    this.updateContentSavedStatus(true)
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
      this.carouselUpdater()
    })
  },
  updated() {
    this.carouselUpdater()
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.CtrlSListener)
    this.editMode(false)
    this.updateContentSavedStatus(true)
    this.setContentData({})
    this.resetFNames()
  },
  computed: {
    ...mapGetters({
      content: 'content/getContent',
      isEditMode: 'contentManager/isEditMode',
      titlePrefix: 'content/getTitlePrefix',
      // Получение типа контента, отображаемого на странице
      // (новости, мероприятия, газпром-классы, вузы-партнеры)
      contentType: 'content/getContentType',
      updater: 'contentManager/getUpdater'
    }),

    isContentManagerPage() {
      return (this.$route.path.includes('/content/events') || this.$route.path.includes('/content/news')
        || this.$route.path.includes('/content/partners') || this.$route.path.includes('/content/classes'))
    },
    avatar() {
      let avatar = this.defaultImage
      if (this.content.contentObject && this.content.contentObject.avatar && this.content.contentObject.files) {
        avatar = `/api/files/${this.content.contentObject.files.find((p) => p.id === this.content.contentObject.avatar).physicalName}`
      }
      return avatar
    },
    images() {
      if (this.content.contentObject && this.content.contentObject.files) {
        const images = this.content.contentObject.files.filter((p) => p.type === 'img')
        return images.map((image) => ({
          source: `/api/files/${image.physicalName}`,
          id: image.id
        }))
      }
      return []
    },
    videos() {
      if (this.content.contentObject && this.content.contentObject.files) {
        const videos = this.content.contentObject.files.filter((p) => p.type === 'video')
        return videos.map((video) => ({
          source: `/api/files/${video.physicalName}`,
          title: video.name,
          id: video.id,
          withPreview: !!(video.description),
          preview: video.description ? `/api/files/${video.description}`
            : 'https://pp.userapi.com/c854328/v854328496/a89ed/_Acd1jm2P-c.jpg'
        }))
      }
      return []
    }
  },
  methods: {
    carouselUpdater() {
      if(document.getElementsByClassName("VueCarousel-inner")[0]) {
        setTimeout(() => { document.getElementsByClassName("VueCarousel-inner")[0].style.visibility = 'visible' }, 10)
      }
    },
    // Слушатель на нажатие Ctrl + S (Сохранение)
    CtrlSListener(e) {
      if (!(e.keyCode === 83 && e.ctrlKey)) {
        return
      }
      e.preventDefault()
      this.updateContentSavedStatus(true)
    },
    changeAvatar() {
      this.workspaceType = 'avatar'
      this.$bvModal.show('files-upload-modal')
    },
    addFileLink() {
      this.workspaceType = ''
      this.$bvModal.show('files-upload-modal')
    },
    addPhoto() {
      this.workspaceType = 'img'
      this.$bvModal.show('files-upload-modal')
    },
    addVideo() {
      this.workspaceType = 'video'
      this.$bvModal.show('files-upload-modal')
    },
    updatePreview(video) {
      this.workspaceType = `preview-${video.id}`
      this.$bvModal.show('files-upload-modal')
    },
    onShowVideo(video) {
      this.$refs.VContentInfoPage.showVideoModal(video.source)
    },
    onShowPhoto(photo) {
      this.$refs.VContentInfoPage.showPhotoModal(photo)
    },
    confirmDeletePhoto(photo) {
      this.onDelete(photo)
      this.$bvModal.show('delete-file-confirmation-modal')
    },
    confirmDeleteVideo(video) {
      this.onDelete(video)
      this.$bvModal.show('delete-file-confirmation-modal')
    },
    confirmDeletePreview(video) {
      this.onDelete(video)
      this.$bvModal.show('preview-confirmation-modal')
    },
    onDeletePreview() {
      this.changeVideoPreview({
        videoId: this.fileOnDelete.id,
        description: null
      })
      this.$bvModal.hide('preview-confirmation-modal')
      this.updateContentSavedStatus(false)
    },
    // Для формы отправки контента спецу по режиму вместе с комментарием (this.form.comment)

    async onSaveClick() {
      this.updateUpdater(0)
      let newId
      if (this.$route.path.includes('/class/content/events')) {
        newId = await this.saveContentByTeacher(this.content.contentObject)
      } else {
        newId = await this.saveContent(this.content.contentObject)
      }
      this.updateContentSavedStatus(true)
      this.editMode(false)
      this.$router.push(`./${newId}`)
    },
    onDeleteAvatar() {
      this.deleteAvatar()
      this.updateContentSavedStatus(false)
    },
    onDelete(file) {
      this.fileOnDelete = file
    },
    onDeleteFile() {
      this.deleteFile(this.fileOnDelete.id)
      this.$bvModal.hide('delete-file-confirmation-modal')
      this.updateContentSavedStatus(false)
    },
    async onDeleteClicked() {
      await this.deleteContent(this.$route.params.id)
      this.$bvModal.hide('delete-confirmation-modal')
      this.$router.push('./')
    },
    onConfirmDeleteContent() {
      this.$bvModal.show('delete-confirmation-modal')
    },
    onCheckRouteForVerSpec() {
      const notExistPath = '/page_not_exist'
      if (!this.isResultOfVerSending && ((this.$route.path.includes('await') && this.content.contentObject.status !== statusFilters.await)
        || (this.$route.path.includes('rejected') && this.content.contentObject.status !== statusFilters.rejected)
        || (this.$route.path.includes('accepted') && this.content.contentObject.status !== statusFilters.accepted)
        || (this.$route.path.includes('removed') && this.content.contentObject.status !== statusFilters.removed))) {
        this.$router.push('..', () => { this.$router.push(notExistPath) })
      }
    },
    onCheckRouteType() {
      const notExistPath = '/page_not_exist'
      if ((this.$route.path.includes('event') && this.content.contentObject.type !== this.typeTranslates_.event)
        || (this.$route.path.includes('news') && this.content.contentObject.type !== this.typeTranslates_.news)
        || (!this.$route.path.includes('class/content/events')
          && this.$route.path.includes('class') && this.content.contentObject.type !== this.typeTranslates_.class)
        || (this.$route.path.includes('partner') && this.content.contentObject.type !== this.typeTranslates_.partner
              && this.content.contentObject.type !== this.typeTranslates_.spo)) {
        if (this.$route.path.includes('await') || this.$route.path.includes('rejected')
          || this.$route.path.includes('accepted') || this.$route.path.includes('removed')
          || this.$route.path.includes('history_of_content')) {
          this.$router.push('..', () => { this.$router.push(notExistPath) })
        } else {
          this.$router.push('.', () => { this.$router.push(notExistPath) })
        }
      }
    },
    closeContent() {
      this.$cookies.set('activeContentButtons', true, '5h')
      this.$router.push('./')
    },
    titleChange(value) {
      this.updateUpdater(this.updater + 1)
      this.updateTitle(value)
      this.updateContentSavedStatus(false)
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    ...mapMutations({
      // переключение режима редактирования (this.editMode(true/false))
      editMode: 'contentManager/editMode',
      // this.updateContentSavedStatus(true/false)
      updateContentSavedStatus: 'contentManager/updateContentSavedStatus',
      setContentData: 'content/setContentData',
      deleteFile: 'content/deleteFile',
      resetFNames: 'content/resetFileNames'
    }),
    ...mapActions({
      saveContent: 'content/saveContent',
      saveContentByTeacher: 'content/saveContentByTeacher',
      changeVideoPreview: 'content/changeVideoPreview',
      deleteContent: 'content/deleteContent',
      updateUpdater: 'contentManager/updateUpdater',
      deleteAvatar: 'content/deleteAvatar',
      updateTitle: 'contentManager/updateTitle'
    })
  }
}
</script>

<style scoped>

.descriptionInfoIcon {
  margin-left: 5px;
  padding: 5px;
  position: relative;
  bottom: 3px;
}

.btn,
.btn:focus,
.btn:active,
.btn:not(:focus) {
  outline: none !important;
  box-shadow: none !important;
}

.title-edit, .date-edit {
  width: 40%;
}

@media only screen and (max-width : 992px) {
  .title-edit, .date-edit {
    width: 60%;
  }
}

@media only screen and (max-width : 768px) {
  .title-edit, .date-edit {
    width: 80%;
  }

  .edit-tolbar {
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center !important;
    text-align: center !important;
    margin-bottom: 20px;
  }
}

@media only screen and (max-width : 480px) {
  .title-edit, .date-edit {
    width: 100%;
  }
}

.editContentCarousel {
  margin-top: 30px;
}

.fullInfoHeader {
  margin-bottom: 16px;
}

.statusButton {
  cursor: default;
}

@media only screen and (min-width : 320px) and (max-width : 431px) {
  .fullInfoEditor {
    height: 30px;
  }
}

.conclusionFile_deleteIcon {
  color: gray;
  cursor: pointer;
}

</style>
